/**
 * Custom Care Banner — interactive vertical step progression.
 * Clicking a step expands its details and mutes the others.
 */
(function () {
  'use strict';

  function CustomCareBanner(root) {
    this.root = root;
    this.steps = Array.prototype.slice.call(
      root.querySelectorAll('[data-ccb-step]')
    );
    if (!this.steps.length) return;

    this.interactive = root.getAttribute('data-ccb-interactive') !== 'false';
    this.bind();
  }

  CustomCareBanner.prototype.bind = function () {
    var self = this;
    this.steps.forEach(function (step, index) {
      var trigger = step.querySelector('[data-ccb-trigger]');
      if (!trigger) return;

      if (!self.interactive) {
        trigger.setAttribute('tabindex', '-1');
        trigger.setAttribute('aria-disabled', 'true');
        return;
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        self.setActive(index);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          self.setActive(index);
        }
      });
    });
  };

  CustomCareBanner.prototype.setActive = function (activeIndex) {
    this.steps.forEach(function (step, index) {
      var isActive = index === activeIndex;
      var trigger = step.querySelector('[data-ccb-trigger]');
      var panel = step.querySelector('[data-ccb-panel]');

      step.classList.toggle('is-active', isActive);
      step.setAttribute('aria-current', isActive ? 'step' : 'false');

      if (trigger) {
        trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
      if (panel) {
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    });
  };

  function init(root) {
    if (!root || root.__ccbInit) return;
    root.__ccbInit = true;
    new CustomCareBanner(root);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll(
      '[data-section-type="custom-care-banner"]'
    );
    Array.prototype.forEach.call(roots, init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });

  if (document.readyState !== 'loading') {
    initAll();
  }
})();
